import { PerUnitAndFlatDiscountComponent } from '@domains/billing-settings/priv/CustomerDiscount/discounts/per-unit-and-flat'
import dayjs from 'dayjs'
import { DiscountModifier, DiscountType } from '../api/api'
import { useCreateCustomerDiscount } from '../api/queries'
import type { CreateCustomerDiscountPlugin, CreateCustomerDiscountPluginComponentProps } from '../components/CreateCustomerDiscountDialog'
import type { PerUnitAndFlatDiscountForm } from '../discounts/per-unit-and-flat'

interface PerUnitFactoryProps extends CreateCustomerDiscountPluginComponentProps {}

export const PerUnitAndFlatDiscountFactory = (props: PerUnitFactoryProps) => {
  const { mutate: createCustomerDiscount, isLoading } = useCreateCustomerDiscount(props.customerId)

  const handleCreatePerUnitAndFlatDiscount = (data: PerUnitAndFlatDiscountForm) => {
    switch (data.discountModifier) {
      case DiscountModifier.PERCENTAGE: {
        return createCustomerDiscount(
          {
            billableId: props.productId,
            discountType: {
              type: DiscountType.PerUnitAndFlatDiscount,
              modifier: data.discountModifier,
              percentageValue: data.discountValue,
            },
            expirationDate: data.expirationDate ? dayjs(data.expirationDate).format('YYYY-MM-DD') : undefined,
          },
          { onSuccess: () => props.onCreatedDiscount() },
        )
      }

      case DiscountModifier.ABSOLUTE: {
        return createCustomerDiscount(
          {
            billableId: props.productId,
            discountType: {
              type: DiscountType.PerUnitAndFlatDiscount,
              modifier: data.discountModifier,
              absoluteAmount: {
                value: data.discountValue,
                currency: props.currency,
              },
            },
            expirationDate: data.expirationDate ? dayjs(data.expirationDate).format('YYYY-MM-DD') : undefined,
          },
          { onSuccess: () => props.onCreatedDiscount() },
        )
      }
    }
  }

  return (
    <PerUnitAndFlatDiscountComponent
      isPatching={isLoading}
      currency={props.currency}
      onCreatePerUnitAndFlatDiscount={handleCreatePerUnitAndFlatDiscount}
    />
  )
}

export class PerUnitAndFlatDiscountPlugin implements CreateCustomerDiscountPlugin {
  name: string = 'Per unit and flat'
  getComponent() {
    return PerUnitAndFlatDiscountFactory
  }
  supports(discountType: string) {
    return discountType === 'Per unit and flat'
  }
}
